import { cn } from "@/shared/utils";
import * as SliderPrimitive from "@radix-ui/react-slider";
import type { ComponentProps } from "react";

type SliderProps = ComponentProps<typeof SliderPrimitive.Root>;

function Slider({ className, defaultValue, value, min = 0, max = 100, ...props }: SliderProps) {
    const values = Array.isArray(value) ? value : Array.isArray(defaultValue) ? defaultValue : [min, max];

    return (
        <SliderPrimitive.Root
            data-slot="slider"
            defaultValue={defaultValue}
            value={value}
            min={min}
            max={max}
            className={cn(
                "relative flex w-full touch-none items-center select-none",
                "data-[disabled]:opacity-50",
                "data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col",
                className
            )}
            {...props}
        >
            <SliderPrimitive.Track
                data-slot="slider-track"
                className={cn(
                    "bg-alpha-default relative grow overflow-hidden rounded-full",
                    "data-[orientation=horizontal]:h-1.5 data-[orientation=horizontal]:w-full",
                    "data-[orientation=vertical]:h-full data-[orientation=vertical]:w-1.5"
                )}
            >
                <SliderPrimitive.Range
                    data-slot="slider-range"
                    className="bg-accent-blue-default absolute data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full"
                />
            </SliderPrimitive.Track>
            {values.map((_, index) => (
                <SliderPrimitive.Thumb
                    data-slot="slider-thumb"
                    key={index}
                    className={cn(
                        "border-accent-blue-default bg-accent-blue-default block size-4 shrink-0 rounded-full border shadow-sm",
                        "ring-ring/50 transition-[color,box-shadow] hover:ring-4 focus-visible:ring-4 focus-visible:outline-hidden",
                        "disabled:pointer-events-none disabled:opacity-50"
                    )}
                />
            ))}
        </SliderPrimitive.Root>
    );
}

Slider.displayName = "Slider";

export { Slider };
